
import {Utilities} from '../../shared/utilities/utilities.model';
import {AttachedFile, BlobTypes} from '../../shared/models/attached-file.model';
import {UploadFileService} from '../../shared/service/upload-file.service';
export class DigitalSignDocument {
	client_document_id: string;
	infocert_document_id: string;
	infocert_document_type: string;
	infocert_signer_id: string;
	policy_compose: boolean;
	policy_sign: boolean;
	policy_archive: boolean;
	file_manager_id: string;
	signature_fields: DigitalSignDocumentFields[];
	archiving_policy: DigitalSignDocumentArchivingPolicyModel;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.client_document_id = model.client_document_id;
			this.infocert_document_id = model.infocert_document_id;
			this.infocert_document_type = model.infocert_document_type;
			this.policy_compose = model.policy_compose;
			this.policy_sign = model.policy_sign;
			this.policy_archive = model.policy_archive;
			this.file_manager_id = model.file_manager_id;
			this.signature_fields = model.signature_fields;
			this.archiving_policy = new DigitalSignDocumentArchivingPolicyModel(model.archiving_policy);
		}
	}
}

export class DigitalSignDocumentFields {
	signer_id: string;
	name: string;
	reason: string;
	location: string;
}

export class DigitalSignDocumentArchivingPolicyModel {
	document_class: string;
	attributes: DigitalSignDocumentArchivingPolicyAttributesModel;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.document_class = model.document_class;
			this.attributes = new DigitalSignDocumentArchivingPolicyAttributesModel(model.attributes);
		}
	}
}

export class DigitalSignDocumentArchivingPolicyAttributesModel {
	doc_type: string;
	file_manager_id: string;
	order_id: any;
	plate: string;
	reference_id: string;
	reference_type: string;
	signer_complete_name: string;
	signer_fiscal_code: string;
	society_name: string;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.doc_type = model.doc_type;
			this.file_manager_id = model.file_manager_id;
			this.order_id = model.order_id;
			this.plate = model.plate;
			this.reference_id = model.reference_id;
			this.reference_type = model.reference_type;
			this.signer_complete_name = model.signer_complete_name;
			this.signer_fiscal_code = model.signer_fiscal_code;
			this.society_name = model.society_name;
		}
	}
}

